/*
 *
 * Dashboard constants
 *
 */

export const GET_LEADER_PROFILE_WATCHER =
  "app/Dashboard/Leader/GET_LEADER_PROFILE_WATCHER"
export const GET_LEADER_PROFILE_SUCCESS =
  "app/Dashboard/Leader/GET_LEADER_PROFILE_SUCCESS"

export const GET_DASHBOARD_WATCHER =
  "app/Dashboard/Leader/GET_DASHBOARD_WATCHER"
export const GET_DASHBOARD_SUCCESS =
  "app/Dashboard/Leader/GET_DASHBOARD_SUCCESS"

export const GET_TASK_WATCHER = "app/Dashboard/Leader/GET_TASK_WATCHER"
export const GET_TASK_SUCCESS = "app/Dashboard/Leader/GET_TASK_SUCCESS"
export const SUBMIT_FEEDBACK_SURVEY_WATCHER = "app/Dashboard/Leader/SUBMIT_FEEDBACK_SURVEY_WATCHER"
export const DISMISS_FEEDBACK_SURVEY_WATCHER = "app/Dashboard/Leader/DISMISS_FEEDBACK_SURVEY_WATCHER"
